<div class="partners d-flex flex-row justify-content-center align-items-center" [ngStyle]="{'background-image': 'url(' + pictureLink + ')'}"></div>